import Controller from '@ember/controller';
import { get, set } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  store: service(),

  error: null,

  delete: task(function* () {
    try {
      yield this.fundsService.confirmValidFundToken();
      let record = get(this, 'model.record');
      yield record.destroyRecord();
      this.send('refreshNotifications');
      this.router.transitionTo('funds.fund.more.notifications.index');
    } catch (error) {
      set(this, 'error', error);
    }
  }).drop(),
});
